import * as R from 'ramda'

import baseConstants from 'config/constants'

export const canCreateSurvey = (user) => {
  const status = R.path(['subscription', 'status'], user)

  return baseConstants.activeSubscriptionStatus.includes(status)
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/AdminSurveys/utils.js